import "./badge.css";
import e from "react";
import { g as _ } from "./elements.utils-DGLsBlHK.mjs";
import t from "./icon.mjs";
const o = {
  "badge-small-info": "_badge-small-info_68vd5_4",
  "badge-small-error": "_badge-small-error_68vd5_4",
  "badge-small-verified": "_badge-small-verified_68vd5_4",
  "badge-small-success": "_badge-small-success_68vd5_4",
  "badge-small-default": "_badge-small-default_68vd5_4",
  "badge-large-info": "_badge-large-info_68vd5_4",
  "badge-large-error": "_badge-large-error_68vd5_4",
  "badge-large-verified": "_badge-large-verified_68vd5_4",
  "badge-large-success": "_badge-large-success_68vd5_4",
  "badge-large-default": "_badge-large-default_68vd5_4"
};
function c({
  children: d,
  icon: l,
  size: g = "large",
  style: s = "default",
  ...a
}) {
  a.className = _(
    a,
    o[`badge-${g.toLowerCase()}-${s.toLowerCase()}`]
  );
  let r = null;
  return l && (r = /* @__PURE__ */ e.createElement(t, { icon: l, color: "currentcolor", size: "small" })), /* @__PURE__ */ e.createElement("div", { ...a }, r, /* @__PURE__ */ e.createElement(e.Fragment, null, d));
}
export {
  c as default
};
